export default __webpack_public_path__ + "media/design-system/icon/assets/brand/SM/calendar-9202d737669c0f7e49216d5bed68f507.svg";